import NextImage from 'next/image';
import Link from "next/link";
import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
  Container,
  Title,
  Button,
  Text,
  Group,
  Image,
  em,
  Divider,
  Box,
  Card,
  Grid,
  List,
  ThemeIcon,
  Center,
  Stack,
  Badge,
  rem,
} from "@mantine/core";
import classes from "../styles/HomePage.module.css";
import stageCss from "../styles/MediaStage.module.css";
// import useTranslation from "@/hooks/useTranslation";
import {
  IconArrowLeft,
  IconCalendarTime,
  IconChartBar,
  IconCheck,
  IconCreditCard,
  IconStar,
  IconBolt,
  IconChartLine,
} from "@tabler/icons";
import { useMediaQuery } from "@mantine/hooks";
import { MainSection } from "@/components/MainSection";
import { MiddleSection } from "@/components/MiddleSection";
import { InventorySection } from "@/components/InventorySection";
// import { CarouselSection } from "@/components/CarouselSection";
import { EndSection } from "@/components/EndSection";
import TypewriterEffect from "@/components/TypeWriterEffect";
import JsonLd from "@/components/JsonLd";
import METATAGSEO from "@/components/metaTagSEO";
import { siteConfig } from "@/components/seoConfig";
import { FeaturesCards } from "@/components/FeaturesCards";
import { QuestionsAndAnswers } from "@/components/QuestionsAndAnswers";
import Section_whatsapp_reminder from "@/components/Section_whatsapp_reminder";
import { BusinessCategoriesSection } from "@/components/BusinessCategoriesSection";
import { FormsSection } from "@/components/FormsSection";
import BackToTopButton from "@/components/BackToTopButton";
import { getAiSource } from "../lib/aiReferral";
// import GoogleReviews from "@/components/GoogleReviews";
// import { GOOGLE_RATING } from "@/components/googleReviewsData";

// const inter = Inter({ subsets: ["latin"] });

export default function Home() {
  // const { t, locale } = useTranslation();
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

  const seoData = {
    title: "QuickTor | מערכת לניהול תורים | ניהול תורים וגביית תשלום אונליין",
    description:
      "פתרון לבעיה במקום אחד עם קוויק תור: ניהול תורים אונליין, תזכורות בוואטסאפ, גביית תשלום מלקוחות, קבלות, דף עסקי ממותג וניהול עובדים. סוף להתעסקות מיותרת!",
    canonicalUrl: siteConfig.baseUrl,
    OgImageUrl: "https://quicktor.co.il/section1.png",
    altText:
      "צילום מסך של מערכת ניהול יומן עם לוח זמנים ופגישות, לצד תזכורות וואטסאפ ללקוחות",
    keywords:
      "מערכת ניהול תורים, יומן חכם, ניהול תורים, זימון תורים, יומן פגישות, תוכנה לניהול יומן, אפליקציה לניהול תורים",
    isPartOf: "https://quicktor.co.il/",
  };

  const BreadcrumbListJson = [
    {
      "@type": "ListItem",
      item: `${siteConfig.baseUrl}/`,
      name: "דף הבית",
      position: 1,
    },
  ];

  const FAQ = {
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "איך מזמינים תור דרך מערכת QuickTor?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "הזמנת תור דרך QuickTor היא פשוטה - לוחצים על הקישור שנשלח מהעסק, בוחרים שירות, בוחרים תאריך ושעה פנויים, ומקבלים אישור מיידי עם תזכורות אוטומטיות.",
        },
      },
      {
        "@type": "Question",
        name: "האם מערכת QuickTor שולחת תזכורות ללקוחות?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "כן, QuickTor שולחת תזכורות אוטומטיות בווטסאפ או SMS לפני התור, מה שמקטין משמעותית את אחוז הנטישה וביטולי התורים ברגע האחרון.",
        },
      },
      {
        "@type": "Question",
        name: "האם אפשר לקבל תשלום מראש על תור דרך QuickTor?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "בהחלט! QuickTor מאפשרת גביית תשלום מראש בעת הזמנת התור, מה שמבטיח הכנסה ומקטין ביטולים. המערכת משתלבת עם מגוון אמצעי תשלום מאובטחים.",
        },
      },
      {
        "@type": "Question",
        name: "איך אפשר להוסיף עובדים למערכת QuickTor ולהגדיר לכל אחד לוח זמנים נפרד?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "הוספת עובדים למערכת QuickTor היא פשוטה וגמישה: דרך לוח הבקרה, ניתן להוסיף עובדים חדשים, להגדיר לכל אחד מהם יומן פעילות נפרד עם שעות עבודה שונות, ימים פנויים וחופשות. הלקוחות יכולים לבחור עובד ספציפי בעת הזמנת התור ולראות רק את השעות הפנויות בלוח הזמנים שלו. ניתן גם להגדיר שירותים שונים לכל עובד ולנהל את התורים והזמינות של כל צוות העסק במקום אחד.",
        },
      },
    ],
  };

  return (
    <>
      <METATAGSEO {...seoData} />
      <JsonLd
        canonical="https://quicktor.co.il"
        title="QuickTor מערכת לניהול תורים"
        description="מערכת לניהול תורים"
        OgImageUrl="https://quicktor.co.il/section1.png"
        isPartOf={`https://quicktor.co.il/`}
        BreadcrumbListJson={BreadcrumbListJson}
        FAQ={FAQ}
        // withReviews כבוי: שתי ביקורות בלי aggregateRating = "פריט לא תקף" ב-Search Console,
        // ודירוג כולל אי אפשר לסמן כי הוא לא מוצג בדף ליד העדויות (הנחיות Google).
      />

      {/* ══ Hero ══ */}
      <header id="hero" className={classes.root}>
        <Container size="xl" style={{ position: "relative", zIndex: 2, width: "100%" }}>

          <div className={classes.heroTwoCol}>

            {/* ── Message Column ── */}
            <div className={classes.heroProofCol}>

              {/* למי זה מיועד — הסימן הראשון שהיא הגיעה למקום הנכון */}
              <p className={classes.heroEyebrow}>
                לקוסמטיקאיות · נייליסטיות · מספרות ומכוני יופי
              </p>

              <Title className={classes.title} order={1}>
                מערכת ניהול תורים
                {" "}
                <Text component="span" inherit className={classes.heroTitleAccent}>
                  בלי הברזות ובלי בלגן
                </Text>
              </Title>

              {/* התוצאה, לא המנגנון — המנגנון כבר מופיע בצ'יפים שמתחת */}
              <p className={classes.heroSub}>
                הידיים שלך עסוקות — העסק ממשיך לעבוד.
              </p>

              {/* מה כלול — סריקה מהירה, לא קריאה */}
              <ul className={classes.heroChips}>
                <li className={classes.heroChip}><span aria-hidden="true">💬</span>תזכורות וואטסאפ אוטומטיות</li>
                <li className={classes.heroChip}><span aria-hidden="true">💳</span>תשלום מראש</li>
                <li className={classes.heroChip}><span aria-hidden="true">🧾</span>חשבוניות כחוק</li>
                <li className={classes.heroChip}><span aria-hidden="true">📅</span>יומן לכל עובדת</li>
              </ul>

              {/* שאלונים — פיצ'ר שלא הוזכר בהירו בכלל; קישור עוגן אמיתי לסקשן המלא */}
              <a
                href="#digital-forms"
                className={classes.heroFormsLink}
                onClick={() => {
                  if (window.gtag) {
                    window.gtag("event", "hero_forms_anchor_click", {
                      event_category: "engagement",
                      event_label: "digital_forms",
                    });
                  }
                }}
              >
                <span className={classes.heroFormsIcon} aria-hidden="true">📋</span>
                <span className={classes.heroFormsText}>
                  <strong>שאלוני בריאות והצהרות</strong>
                  הלקוחה ממלאת וחותמת דיגיטלית
                </span>
                <span className={classes.heroFormsCta} aria-hidden="true">איך זה עובד ↓</span>
              </a>

              {/* מחיר — היה קבור בתחתית הדף, עכשיו במסך הראשון.
                  כל הריבוע לחיץ ומוביל לדף המחירים המלא */}
              <Link
                href="/pricing"
                className={classes.heroPrice}
                aria-label="99 ש״ח לחודש, הכל כלול — לכל פרטי המחיר"
                onClick={() => {
                  if (window.gtag) {
                    window.gtag("event", "hero_price_click", {
                      event_category: "engagement",
                      event_label: "pricing_page",
                    });
                  }
                }}
              >
                <div className={classes.heroPriceMain}>
                  <span className={classes.heroPriceAmount}>
                    99<span className={classes.heroPriceCurrency}>&#1513;&#1524;&#1495;</span>
                  </span>
                  <span className={classes.heroPriceUnit}>לחודש</span>
                  <span className={classes.heroPriceAll}>הכל כלול</span>
                </div>
                <div className={classes.heroPriceNote}>
                  14 יום ניסיון חינם · בלי התחייבות
                  <span className={classes.heroPriceCta} aria-hidden="true">לכל הפרטים ←</span>
                </div>
              </Link>

            </div>

            <div className={classes.heroTrustRow}>
              <div className={classes.heroAvatarStack}>
                {[
                  { l: "א", bg: "linear-gradient(135deg,#f093fb,#f5576c)" },
                  { l: "נ", bg: "linear-gradient(135deg,#4facfe,#00f2fe)" },
                  { l: "ש", bg: "linear-gradient(135deg,#43e97b,#38f9d7)" },
                  { l: "ר", bg: "linear-gradient(135deg,#fa709a,#fee140)" },
                  { l: "מ", bg: "linear-gradient(135deg,#a18cd1,#fbc2eb)" },
                ].map((a, i) => (
                  <div key={i} className={classes.heroAvatar} style={{ background: a.bg }}>{a.l}</div>
                ))}
              </div>
              <div>
                <div style={{ display: "flex", gap: 2 }}>
                  {[1, 2, 3, 4, 5].map(s => <span key={s} style={{ color: "#ffe066", fontSize: "0.9rem" }}>★</span>)}
                </div>
                <Text size="xs" c="white" fw={500} style={{ opacity: 0.85, marginTop: 2 }}>
                  קרוב ל-100 עסקי יופי כבר פתחו חשבון ב-QuickTor
                </Text>
              </div>
            </div>

            {/* ── Form Column ── */}
            <div className={classes.heroFormCardCol}>
              <HeroRegisterForm />
            </div>



          </div>

          {/* Desktop-only Scroll Down CTA */}
          <div className={`${classes.heroScrollDown} ${classes.desktopOnlyScrollDown}`}>
            <button
              onClick={() => document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' })}
              className={classes.heroScrollBtn}
            >
              <span>מה הלקוחות אומרות עלינו?</span>
              <div className={classes.heroScrollIcon}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 5v14M19 12l-7 7-7-7" />
                </svg>
              </div>
            </button>
          </div>
        </Container>
      </header>
      
      <main>

      {/* ══ Video Testimonial ══ */}
      <section id="reviews">
        <VideoTestimonial />
        {/* <GoogleReviews /> */}
      </section>

      {/* Hero AI Description */}
      <Container size="md" py="xl">
        <div className="hero-description" style={{ 
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderRadius: '20px',
          padding: '30px 20px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.03)',
          border: '1px solid rgba(255,255,255,0.5)',
          maxWidth: '750px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <Text c="dimmed" style={{ lineHeight: 1.8, fontSize: '0.95rem' }}>
            <span style={{ fontWeight: 700, color: '#333' }}>QuickTor</span> נוצרה כדי לתת פתרון אחד, שלם ופשוט לעסקי יופי וקליניקות בישראל – בלי אותיות קטנות ובלי לשלם למספר אפליקציות במקביל. תמורת מחיר קבוע של 99₪ לחודש, המערכת הופכת כל קליניקה לעסק חכם יותר: הלקוחות קובעים תורים עצמאית, תזכורות WhatsApp נשלחות אוטומטית כדי לחסל "הברזות", וכל הניהול היומיומי מרוכז במקום אחד. קוסמטיקאיות ומספרות ברחבי הארץ כבר בחרו להחזיר לעצמן את השקט הנפשי.
          </Text>
        </div>
      </Container>

      {/* ══ Features Strip ══ */}
      <section className={classes.featuresStripSection}>
        <HeroFeaturesStrip />
      </section>

      {/* ══ Big CTA ══ */}
      <section className={classes.bigCtaSection}>
        <BigHeroCta />
      </section>

      {/* Main Content Container */}
      <Container size="xl" fluid style={{ position: "relative", zIndex: 1 }}>
        {/* Hero Image - Floating Effect */}
        <Box
          className={stageCss.hero}
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: !isMobile ? -80 : -60,
            marginBottom: rem(50),
            position: "relative",
            zIndex: 10,
          }}
        >
          <span className={stageCss.heroBlobA} aria-hidden="true" />
          <span className={stageCss.heroBlobB} aria-hidden="true" />
          <NextImage
            className={stageCss.heroImg}
            src="/sectionmainpage.webp"
            alt="יומן התורים של QuickTor במחשב לצד דף העסק בטלפון, עם תשלום מראש בקביעת התור, תזכורת בוואטסאפ וסגירת חוב ללקוחה"
            width={1390}
            height={1080}
            sizes="(max-width: 1240px) 100vw, 1200px"
            quality={85}
            style={{ maxWidth: 1200 }}
          />
        </Box>

        {/* Business Categories Section */}
        <section id="business-categories-section" style={{ marginTop: rem(40) }}>
          <BusinessCategoriesSection />
        </section>

        {/* Main Features Section */}
        <section id="business-page-appointment" style={{ paddingTop: rem(60) }}>
          <MainSection />
        </section>

        {/* WhatsApp Reminder Section */}
        <section id="whatsapp-reminder" style={{ paddingTop: rem(60) }}>
          <Section_whatsapp_reminder />
        </section>

        {/* Premium Divider */}
        <Divider
          size="sm"
          my={rem(60)}
          style={{
            border: "none",
            height: "1px",
            background: "linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0.1) 80%, transparent 100%)",
          }}
        />

        {/* Payment Solutions Section */}
        <section id="payment-solutions" style={{ paddingTop: rem(40) }}>
          <MiddleSection />
        </section>

        {/* Inventory Management Section */}
        <section id="inventory-management" style={{ paddingTop: rem(60) }}>
          <InventorySection />
        </section>

      </Container>

      {/* Digital Forms Section — full-width dark section */}
      <section id="digital-forms" style={{ marginTop: rem(60), scrollMarginTop: rem(96) }}>
        <FormsSection />
      </section>

      <Container size="xl" fluid style={{ position: "relative", zIndex: 1 }}>

        {/* Reports and Statistics Section */}
        <section id="Reports-and-statistics" style={{ paddingTop: rem(60) }}>
          <EndSection />
        </section>

        {/* Features Cards Section */}
        <section id="feature-description-tabs" style={{ paddingTop: rem(60) }}>
          <FeaturesCards />
        </section>

        {/* Premium CTA Section */}
        <Card
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "20px",
            padding: rem(40),
            marginTop: rem(60),
            marginBottom: rem(60),
            boxShadow: "0 12px 35px rgba(102, 126, 234, 0.25)",
            border: "none",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
              pointerEvents: "none",
            }}
          />
          <Grid align="center" style={{ position: "relative", zIndex: 1 }}>
            <Grid.Col span={{ base: 12, md: 8 }}>
              <Title order={2} c="white" mb={12} fw={800} size={rem(24)}>
                מוכנים להפוך את ניהול התורים לפשוט וחכם?
              </Title>
              <Text c="white" size="md" style={{ opacity: 0.95, lineHeight: 1.6 }}>
                השיקו את העסק שלכם עם מערכת שתחסוך לכם זמן יקר, תייעל את
                התהליכים ותספק חווית לקוח מעולה. 14 ימי ניסיון מלאים + הדרכה
                אישית ללא התחייבות!
              </Text>
              <Text c="white" size="md" fw={700} mt="md" style={{ opacity: 0.95, lineHeight: 1.6 }}>
                עוברים אלינו ממערכת אחרת? אנחנו עושים את העבודה הקשה בשבילכם! שירות הגירה והעברת כל נתוני הלקוחות וההיסטוריה מקובץ או מערכת קודמת - בחינם לחלוטין ובליווי אישי.
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4 }} ta="right">
              <Button
                size="lg"
                variant="white"
                color="dark"
                rightSection={<IconArrowLeft />}
                component="a"
                href="https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount"
                style={{
                  fontWeight: 700,
                  borderRadius: "50px",
                  padding: `${rem(12)} ${rem(24)}`,
                  boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.15)";
                }}
              >
                פתח חשבון חינם
              </Button>
            </Grid.Col>
          </Grid>
        </Card>

        {/* Benefits Section - Premium Design */}
        <section id="benefits-section" style={{ paddingTop: rem(60) }}>
          <Box mb={50} py="lg">
            <Center mb={40}>
              <Stack gap="sm" align="center">
                <Title
                  order={2}
                  ta="center"
                  className={classes.Benefits_Section}
                  size={rem(28)}
                >
                  למה לבחור במערכת שלנו?
                </Title>
                <Text size="md" c="dimmed" ta="center" maw={600}>
                  יתרונות ייחודיים שהופכים את QuickTor לפתרון המושלם לעסק שלכם
                </Text>
              </Stack>
            </Center>

            <Grid gutter={{ base: "md", md: "xl" }}>
              <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                <Card
                  shadow="md"
                  padding="xl"
                  radius="xl"
                  withBorder
                  h="100%"
                  className={classes.premiumCard}
                  style={{
                    border: "1px solid rgba(0, 0, 0, 0.06)",
                  }}
                >
                  <ThemeIcon
                    size={64}
                    radius="xl"
                    mb={20}
                    variant="light"
                    style={{
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "white",
                    }}
                  >
                    <IconCalendarTime size={32} />
                  </ThemeIcon>
                  <Title order={3} fw={700} mb={12} size="h4">
                    פיתוח ישיר על ידי הבעלים
                  </Title>
                  <Text size="md" c="dimmed" lh={1.7}>
                    מערכת QuickTor פותחה ומתוחזקת ישירות על ידי הבעלים, המתכנת
                    הראשי של המערכת בליווי צוות פיתוח שנבחר בקפידה! . זה מבטיח עדכונים מהירים, פתרון תקלות מיידי,
                    והבנה עמוקה של צרכי המשתמשים.
                  </Text>
                  <Text
                    component="a"
                    href="/about"
                    variant="link"
                    fw={600}
                    mt={16}
                    style={{ color: "#667eea" }}
                  >
                    קראו עוד על הסיפור שלנו →
                  </Text>
                </Card>
              </Grid.Col>

              <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                <Card
                  shadow="md"
                  padding="xl"
                  radius="xl"
                  withBorder
                  h="100%"
                  className={classes.premiumCard}
                >
                  <ThemeIcon
                    size={64}
                    radius="xl"
                    mb={20}
                    variant="light"
                    color="green"
                    style={{
                      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      color: "white",
                    }}
                  >
                    <IconCheck size={32} />
                  </ThemeIcon>
                  <Title order={3} fw={700} mb={12} size="h4">
                    שירות לקוחות ותמיכה טכנית במקום אחד
                  </Title>
                  <Text size="md" c="dimmed" lh={1.7}>
                    אנחנו מאמינים בשירות אישי וזמין. בניגוד למערכות אחרות,
                    ב-QuickTor התמיכה הטכנית ושירות הלקוחות מרוכזים במקום אחד,
                    מה שמבטיח מענה מהיר ויעיל לכל שאלה או אתגר.
                  </Text>
                </Card>
              </Grid.Col>

              <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                <Card
                  shadow="md"
                  padding="xl"
                  radius="xl"
                  withBorder
                  h="100%"
                  className={classes.premiumCard}
                >
                  <ThemeIcon
                    size={64}
                    radius="xl"
                    mb={20}
                    variant="light"
                    color="violet"
                    style={{
                      background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                      color: "white",
                    }}
                  >
                    <IconChartBar size={32} />
                  </ThemeIcon>
                  <Title order={3} fw={700} mb={12} size="h4">
                    התאמה מתמדת לצרכי הלקוחות
                  </Title>
                  <Text size="md" c="dimmed" lh={1.7}>
                    אנחנו מחויבים לשיפור מתמיד של המערכת בהתאם לצרכים המשתנים של
                    הלקוחות שלנו. QuickTor מתפתחת בהתאם למשוב אמיתי מהשטח, ומציעה
                    פתרונות חדשניים.
                  </Text>
                </Card>
              </Grid.Col>

              <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
                <Card
                  shadow="md"
                  padding="xl"
                  radius="xl"
                  withBorder
                  h="100%"
                  className={classes.premiumCard}
                  style={{
                    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                    border: "2px solid #3b82f6",
                  }}
                >
                  <ThemeIcon
                    size={64}
                    radius="xl"
                    mb={20}
                    variant="light"
                    color="blue"
                    style={{
                      background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                      color: "white",
                    }}
                  >
                    <IconCreditCard size={32} />
                  </ThemeIcon>
                  <Title order={3} fw={700} mb={12} size="h4">
                    מחיר אחד, הכל כלול
                  </Title>
                  <Text size="md" c="dimmed" lh={1.7} mb={16}>
                    99₪ לחודש לכל הפיצ&apos;רים: ניהול תורים, תזכורות וואטסאפ, דף
                    עסקי, גביית תשלומים, סטטיסטיקות וניהול עובדות. בלי דמי הקמה
                    ובלי תוספת על עובדות.
                  </Text>
                  <Text
                    component="a"
                    href="/pricing"
                    fw={700}
                    size="xl"
                    style={{ color: "#2563eb" }}
                  >
                    רק 99 ש&quot;ח לחודש! →
                  </Text>
                </Card>
              </Grid.Col>
            </Grid>
          </Box>
        </section>

        {/* Questions and Answers Section */}
        <section style={{ paddingTop: rem(60), paddingBottom: rem(60) }}>
          <QuestionsAndAnswers />
        </section>
      </Container>
      </main>

      {/* כפתור חזרה ל-hero — מופיע רק אחרי שגוללים מתחת ל-hero */}
      <BackToTopButton targetId="hero" />
    </>
  );
}

const BUSINESS_TYPES = [
  "💅 נייליסטים / גל סילקון",
  "💄 קוסמטיקאים",
  "✂️ סלונאים / ספרים",
  "👁️ עיצוב גבות וריסים",
  "🧖 מיקרובליידינג / טיפול פנים",
  "💪 מסאזיסטים / רפואת ספא",
  "💇 סלון שיער ואירועים",
  "✨ הסרת שערות / לייזר",
  "💆 רפיות ספא",
  "🧔 מאפרות / פיגמנטציה",
  "🏋️ מאמנים / אנשי כושר",
  "🥺 אחר",
];

/* ─── Hero Registration Form Component ─── */
function HeroRegisterForm() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [failed, setFailed] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [spotsLeft] = useState(4); // urgency counter

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    
    // 1. שמירת הליד ישירות למייל בעזרת EmailJS
    const templateParams = {
      CustomerName: name,
      Phone: phone,
      Email: "לא סופק (טופס דף הבית)",
      Subject: "ליד חדש מדף הבית (Hero Section)!",
      ContentMessage: "ליד זה הגיע דרך הטופס הראשי בדף הבית שבו מוזנים רק שם וטלפון.",
    };

    setSending(true);
    setFailed(false);

    try {
      await emailjs.send(
        "service_3tsfpws",
        "template_awkij5s",
        templateParams,
        "6NXMdn4WbMJebcaGG"
      );
    } catch (err) {
      // הליד לא נשלח. אסור לדווח על הצלחה ואסור לספור המרה —
      // אחרת הליד נעלם והדוחות מראים אותו כאילו התקבל.
      console.error("EMAILJS FAILED...", err);
      if (window.gtag) {
        window.gtag('event', 'lead_submit_failed', {
          event_category: 'conversion',
          event_label: 'hero_form'
        });
      }
      setSending(false);
      setFailed(true);
      return;
    }

    // מכאן והלאה — רק אחרי שהשליחה באמת הצליחה.
    if (window.gtag) {
      window.gtag('event', 'generate_lead', {
        event_category: 'conversion',
        event_label: 'hero_form',
        ai_source: getAiSource()
      });
    }
    if (window.fbq) window.fbq('track', 'Lead');

    setSending(false);
    setSubmitted(true);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={classes.heroForm}
      style={{ animation: "fadeInUp 1s ease-out 0.55s both" }}
    >
      {submitted ? (
        <div className={classes.heroFormSuccess}>
          <span className={classes.heroFormSuccessIcon}>✓</span>
          <div>
            <div style={{ fontWeight: 800, fontSize: "1.1rem" }}>מעולה! נחזור אליך תוך דקות 🎉</div>
            <div style={{ fontSize: "0.85rem", opacity: 0.85, marginTop: 4 }}>
              בוואטסאפ — ניתן לכם הדגמה אישית מותאמת לעסק שלכם
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* Urgency strip */}
          {/* <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            background: "rgba(255,224,102,0.18)",
            border: "1px solid rgba(255,224,102,0.4)",
            borderRadius: 10,
            padding: "7px 14px",
            marginBottom: 16,
          }}>
            <span style={{ fontSize: "0.95rem" }}>🔥</span>
            <span style={{
              color: "#ffe066",
              fontFamily: "'Rubik','Heebo',sans-serif",
              fontWeight: 700,
              fontSize: "0.82rem",
              letterSpacing: "0.01em",
            }}>
              נותרו רק {spotsLeft} מקומות פנויים לחודש יוני לליווי אישי חינם
            </span>
          </div> */}

          <p className={classes.heroFormLabel}>
            📲 השאירו פרטים — נחזור אליכם תוך דקות
          </p>

          {/* Single row: Name + Phone */}
          <div className={classes.heroFormFields}>
            <div className={`${classes.heroFormInputWrap} ${focusedField === "name" ? classes.heroFormInputFocused : ""}`}>
              <span className={classes.heroFormIcon}>👤</span>
              <input
                id="hero-register-name"
                type="text"
                placeholder="שם פרטי"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => setFocusedField("name")}
                onBlur={() => setFocusedField(null)}
                required
                className={classes.heroFormInput}
                autoComplete="given-name"
              />
            </div>
            <div className={`${classes.heroFormInputWrap} ${focusedField === "phone" ? classes.heroFormInputFocused : ""}`}>
              <span className={classes.heroFormIcon}>📱</span>
              <input
                id="hero-register-phone"
                type="tel"
                placeholder="מספר טלפון"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                onFocus={() => setFocusedField("phone")}
                onBlur={() => setFocusedField(null)}
                required
                className={classes.heroFormInput}
                autoComplete="tel"
                dir="ltr"
              />
            </div>
          </div>

          {/* Submit button — full width */}
          <button
            type="submit"
            disabled={sending}
            className={classes.heroFormBtn}
            style={{
              width: "100%",
              justifyContent: "center",
              marginTop: 12,
              height: 54,
              fontSize: "1.05rem",
              opacity: sending ? 0.7 : 1,
              cursor: sending ? "wait" : "pointer",
            }}
          >
            <span>{sending ? "שולח…" : "קבלו הדגמה אישית ←"}</span>
          </button>

          {/* כשל שליחה — הליד לא הגיע, אז חייבים לתת מסלול חלופי ולא להעמיד פנים שהכל תקין */}
          {failed && (
            <div
              role="alert"
              style={{
                marginTop: 12,
                padding: "12px 14px",
                borderRadius: 12,
                background: "rgba(255,90,90,0.14)",
                border: "1px solid rgba(255,120,120,0.45)",
                color: "#fff",
                fontSize: "0.85rem",
                lineHeight: 1.6,
              }}
            >
              <strong>השליחה נכשלה.</strong> אל תוותרו — אפשר לנסות שוב, או לפנות ישירות:{" "}
              <a
                href={`https://wa.me/972557259188?text=${encodeURIComponent(
                  `שלום, נסיתי להשאיר פרטים באתר והטופס נתקע. שמי ${name}, הטלפון שלי ${phone}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ffe066", fontWeight: 700, textDecoration: "underline" }}
              >
                וואטסאפ
              </a>{" "}
              ·{" "}
              <a href="tel:+972557259188" style={{ color: "#ffe066", fontWeight: 700, textDecoration: "underline" }}>
                055-725-9188
              </a>
            </div>
          )}

          {/* Trust row */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            marginTop: 12,
            flexWrap: "wrap",
          }}>
            <span style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.75rem", fontFamily: "'Rubik','Heebo',sans-serif" }}>
              ✅ ללא התחייבות
            </span>
            <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" }}>|</span>
            <span style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.75rem", fontFamily: "'Rubik','Heebo',sans-serif" }}>
              🔒 הפרטים שמורים אצלנו בלבד
            </span>
            <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" }}>|</span>
            <a
              href="tel:+972557259188"
              style={{
                color: "rgba(255,255,255,0.75)",
                fontSize: "0.75rem",
                fontFamily: "'Rubik','Heebo',sans-serif",
                textDecoration: "underline",
                textDecorationColor: "rgba(255,255,255,0.35)",
                fontWeight: 600,
              }}
            >
              📞 או התקשרו: 055-725-9188
            </a>
          </div>
        </>
      )}
    </form>
  );
}


/* ── Video Testimonial Carousel ── */
const VIDEO_TESTIMONIALS = [
  {
    src: "https://res.cloudinary.com/ddt9g5tf0/video/upload/v1780394833/elena_review_lmuoka.mp4",
    // Cloudinary auto-thumbnail: first frame as poster image
    poster: "https://res.cloudinary.com/ddt9g5tf0/video/upload/so_0/v1780394833/elena_review_lmuoka.webp",
    name: "אלנה",
    role: "בעלת קליניקה למכון לייזר",
    quote: "חסכתי 3 שעות בשבוע — בלי לעשות כלום",
  },
  {
    src: "https://res.cloudinary.com/ddt9g5tf0/video/upload/v1780392738/eati_review_ootpfu.mov",
    poster: "https://res.cloudinary.com/ddt9g5tf0/video/upload/so_0/v1780392738/eati_review_ootpfu.webp",
    name: "אתי",
    role: "קוסמטיקאית פרא רפואית",
    quote: "הלקוחות מבטלות פחות — הכסף נשאר בחשבון",
  },
];

function VideoCard({ video, isActive, onClick }) {
  const [playing, setPlaying] = useState(false);
  const videoRef = React.useRef(null);

  // Stop playback when card is no longer active
  React.useEffect(() => {
    if (!isActive && videoRef.current) {
      videoRef.current.pause();
    }
  }, [isActive]);

  const handleCardClick = () => {
    if (!isActive) {
      onClick();
      return;
    }
    const vid = videoRef.current;
    if (!vid) return;
    // Fix 1: use the actual DOM paused state — not React state — to avoid double-click race
    if (vid.paused) {
      vid.play().catch(() => { });
    } else {
      vid.pause();
    }
  };

  return (
    <div
      className={`${classes.vcCard} ${isActive ? classes.vcCardActive : classes.vcCardSide}`}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleCardClick()}
      aria-label={isActive ? (playing ? "עצור סרטון" : "הפעל סרטון") : `עבור ל${video.name}`}
    >
      {/* Phone-frame notch */}
      <div className={classes.vcFrame}>
        <div className={classes.vcNotch} />

        <video
          ref={videoRef}
          className={classes.vcVideo}
          src={video.src}
          poster={video.poster}
          playsInline
          preload="metadata"
          loop
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          onEnded={() => setPlaying(false)}
        />

        {/* Fix 2: hide gradient when playing so subtitles are visible */}
        {!playing && <div className={classes.vcGradient} />}

        {/* Play overlay — only on active card, hidden when playing */}
        {isActive && !playing && (
          <div className={classes.vcPlayOverlay}>
            <div className={classes.vcPlayBtn}>
              <svg width="26" height="26" viewBox="0 0 24 24">
                <polygon points="6,3 20,12 6,21" fill="#667eea" />
              </svg>
            </div>
            <p className={classes.vcPlayHint}>לחץ להפעלה</p>
          </div>
        )}

        {/* Info badge — always visible */}
        <div className={classes.vcBadge}>
          <span className={classes.vcBadgeName}>{video.name}</span>
          <span className={classes.vcBadgeRole}>{video.role}</span>
        </div>
      </div>
    </div>
  );
}

function VideoTestimonial() {
  const [activeIdx, setActiveIdx] = useState(0);
  const total = VIDEO_TESTIMONIALS.length;
  const touchStartX = React.useRef(null);
  const touchStartY = React.useRef(null);

  const prev = () => setActiveIdx((i) => (i - 1 + total) % total);
  const next = () => setActiveIdx((i) => (i + 1) % total);

  /* ── Touch / Swipe ── */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      // RTL site: swipe left → next, swipe right → prev
      dx < 0 ? next() : prev();
    }
    touchStartX.current = null;
    touchStartY.current = null;
  };

  const prevIdx = (activeIdx - 1 + total) % total;
  const nextIdx = (activeIdx + 1) % total;

  return (
    <section className={classes.videoSection2}>
      {/* Header */}
      <div className={classes.videoHeader}>
        <Text className={classes.videoEyebrow}>הלקוחות המדהימות שלנו</Text>
        <Title order={2} className={classes.videoTitle}>
          &quot;{VIDEO_TESTIMONIALS[activeIdx].quote}&quot;
        </Title>
      </div>

      {/* Peek carousel track */}
      <div
        className={classes.vcTrack}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {/* Prev peek — key forces fresh instance when video changes */}
        <VideoCard
          key={`prev-${prevIdx}`}
          video={VIDEO_TESTIMONIALS[prevIdx]}
          isActive={false}
          onClick={prev}
        />

        {/* Active center card — key resets playing state on every switch */}
        <VideoCard
          key={`active-${activeIdx}`}
          video={VIDEO_TESTIMONIALS[activeIdx]}
          isActive={true}
          onClick={() => { }}
        />

        {/* Next peek */}
        <VideoCard
          key={`next-${nextIdx}`}
          video={VIDEO_TESTIMONIALS[nextIdx]}
          isActive={false}
          onClick={next}
        />
      </div>

      {/* Dots */}
      <div className={classes.videoCarouselDots}>
        {VIDEO_TESTIMONIALS.map((_, i) => (
          <button
            key={i}
            className={`${classes.videoCarouselDot} ${i === activeIdx ? classes.videoCarouselDotActive : ""}`}
            onClick={() => setActiveIdx(i)}
            aria-label={`ביקורת ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}

/* ── Features Strip ── */
function HeroFeaturesStrip() {
  const features = [
    { icon: "📅", title: "יומן חכם", desc: "תורים אוטומטיים 24/7" },
    { icon: "💬", title: "תזכורות וואטסאפ", desc: "פחות ביטולים ברגע האחרון" },
    { icon: "💳", title: "גביית תשלום", desc: "כסף בחשבון לפני התור" },
    { icon: "📊", title: "דוחות ביצועים", desc: "דעו מאיפה הכסף מגיע" },
  ];
  return (
    <Container size="lg">
      <div className={classes.featuresStripGrid}>
        {features.map((f, i) => (
          <div key={i} className={classes.featureStripCard}>
            <span className={classes.featureStripEmoji}>{f.icon}</span>
            <div>
              <Text fw={800} size="md" className={classes.featureStripTitle}>{f.title}</Text>
              <Text size="sm" c="dimmed">{f.desc}</Text>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}

/* ── Big CTA ── */
function BigHeroCta() {
  return (
    <div className={classes.bigCtaWrap}>
      <Container size="sm" style={{ textAlign: "center" }}>
        <Text className={classes.bigCtaEyebrow}>מוכנים להתחיל?</Text>
        <Title order={2} className={classes.bigCtaTitle}>
          14 ימי ניסיון חינם
        </Title>
        <Text size="md" c="dimmed" mt={8} mb="xl" maw={460} mx="auto">
          קרוב ל-100 עסקים כבר פתחו חשבון ב-QuickTor, הצטרפו גם אתם
        </Text>
        <Button
          component="a"
          href="https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount"
          size="xl"
          className={classes.bigCtaBtn}
          rightSection={<IconArrowLeft size={20} />}
          leftSection={<IconBolt size={20} />}
        >
          התחילו 14 ימי ניסיון חינם
        </Button>
        <Text size="xs" c="dimmed" mt={12}>ללא התחייבות · ביטול בכל עת · הגדרה ב-10 דקות</Text>
      </Container>
    </div>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
